module.exports = __webpack_public_path__ + "img/ic_online_service.569f219e.png";